// @flow
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './NewProductLayoutComponent.scss';

import CloseButton from '../../../common/close-button/CloseButtonComponent';
import BackButton from '../../../common/back-button/BackButtonComponent';

import { envUrl } from '../../../services/environment/EnvironmentService';

/*
This component contains the page structure (Back button, close button)
that is used in all the creation pages - both for full upload and templates.
Long-term plan is to remove the overlay look.
*/

type Props = {
  parentLocation: string | null,
  onCloseCallback?: Function,
  onBackCallback?: Function,
  children: Node,
  history: any,
};

const NewProductLayoutComponent = (props: Props) => {
  const { onCloseCallback, onBackCallback, children, history } = props;

  const onBackClick = () => {
    history.goBack();

    if (onBackCallback) {
      onBackCallback();
    }
  };

  const onCloseClick = () => {
    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  const to = props.parentLocation || envUrl('/products');

  return (
    <div className="new-product-layout-component">
      <BackButton onClick={onBackClick} />
      {children}
      <Link to={to}>
        <CloseButton alignRight onClick={onCloseClick} />
      </Link>
    </div>
  );
};

NewProductLayoutComponent.propTypes = {
  parentLocation: PropTypes.string,
  onCloseCallback: PropTypes.func,
  onBackCallback: PropTypes.func,
  children: PropTypes.node,
};

NewProductLayoutComponent.displayName = 'NewProductLayoutComponent';

export default withRouter(NewProductLayoutComponent);
